import { useEffect, useRef } from 'react';

export const useOnClickOutside = (handler: (e: Event) => void) => {
  const ref = useRef<any>();

  // Keep the latest handler in a ref so the listeners are bound once instead of
  // being torn down and re-added on every render (callers usually pass an inline
  // handler, whose identity changes each render).
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const listener = (event: Event) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handlerRef.current(event);
    };

    document.addEventListener('mouseup', listener);
    document.addEventListener('touchend', listener);

    return () => {
      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchend', listener);
    };
  }, []);

  return {
    ref,
  };
};
